import React from "react";
import {Drawer, Form, Button, Col, Row, Input, Select, DatePicker} from 'antd';
import {
    findRecordKey2,
    findRecordType,
    GetListField,
    LoadDataAnyEndpoint,
    SortData,
    SubmitLogInformation
} from "../../../api/fn";
import {fetchDataEntity} from "../../../api/entity-data";
import moment from "moment";
import {GetUserToken} from "../../../api/token";


const {Option} = Select;

const makeCol = (row, _this) => {
    let {state, handleChangeInput, handleChangeInput2} = _this;
    if (row === null) {
        return null;
    }
    if (row.datatype === "list") {
        let options = [];
        for (let i in row.options) {
            const key = i;
            const val = i;
            options.push({
                key: key,
                val: val,
            })
        }
        return (
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.fieldname}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <Select
                        placeholder={"Please enter user " + row.fieldname}
                        onChange={(e) => handleChangeInput(e, row.fieldname)}
                    >
                        {options.map(rec => {
                            return (
                                <Option value={rec.key}>{rec.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Col>
        )
    }
    return (
        <Col span={12}>
            <Form.Item
                name={row.fieldname}
                label={row.fieldname}
                rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
            >
                <Input
                    placeholder={"Please enter user " + row.fieldname}
                    onChange={(e) => handleChangeInput(e.target.value, row.fieldname)}
                />
            </Form.Item>
        </Col>
    )
}

export default class NewActivityDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            selectedActivity:"",
            newEntry:{},
        }
    }

    handleChange = async (e, key) => {
        const value = e.value;
        console.log("handleChange --> ",key," > ",value);
        this.setState({
            [key]: value,
        });

    }
    handleChangeInput=(val,key)=>{
        let tmp=this.state;
        tmp.newEntry[key]=val;
        this.setState(tmp);
        console.log("handleChangeInput > ",key," > ",val);
    }
    validateSubmitINput=()=>{
        let attributes=this.getAttributes();
        let newEntry = this.state.newEntry;
        for(let i in attributes){
            const row = attributes[i];
            console.log("validateSubmitINput > ",newEntry[row.fieldname],row.fieldname,attributes);
            console.log("validateSubmitINput 2  > ",newEntry);
            if(row.mandatory){
                if(typeof newEntry[row.fieldname]==="undefined"){
                    alert("Sorry "+row.fieldname+" is required field and can't be empty!");
                    return false;
                }
                if(newEntry[row.fieldname]===""){
                    alert("Sorry "+row.fieldname+" is required field and can't be empty!");
                    return false;
                }
            }
        }
        return true;
    }

    onSubmit=async ()=>{
        if(!this.validateSubmitINput()){
            return
        }
        let self=this;

        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }

        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;
        let data = state.ActionData;
        if(data===null){return }
        let org = data.record.org;
        let project = data.record.module;

        let fieldsList = this.getAttributes();


        let o = {};
        for (let i in fieldsList) {
            const row = fieldsList[i];
            const key = row.fieldname;
            let val = this.state.newEntry[key];
            const type =row.datatype;
            if (type === "float") {
                //val = parseFloat(val)
            } else if (type === "number") {
                //val = parseInt(val)
            } else if (type === "boolean") {
                val = val === "yes"
            } else {
                //todo do nothing
            }
            o[key] = val;
        }

        let workDate = moment().format("YYYY-MM-DD");
        let userInfo = GetUserToken();
        let username  = userInfo.Username;


        let hub = {
            Org: org,
            project: project,
            Data: o,
            Ref: data.record.ref,
            Action:"activity",
            Category:"all",
            Name:this.state.selectedActivity,
            WorkDate:workDate,
            Username:username,
        }


        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/Informations/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmit new activity send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this,async (dataOut) => {
            console.log("onSubmit new activity response > ", dataOut);
            self.onClose();
            _this.setState({
                newEntry:{},
            });
            await _this.afterAddReload()
           // await SubmitLogInformation(org,project,"activity","all",self.state.selectedActivity,data.record.ref,o,self)
            alert("Thank you record added!")

        });

    }

    getAttributes=()=>{
        let ls=[];
        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;
        let data = state.ActionData;
        if(data===null){return ls}
        if(typeof data.record ==="undefined"){return ls}
        let org = data.record.org;
        let project = data.record.module;

        console.log("New Attribute GetAtt> ",data);
        let fields = SortData("position",state.Fields);
        for(let  i in fields){
            let row =fields[i];
            if(row.org!==org){continue}
            if(row.module!==project){continue}
            if(row.category!=="activity"){continue}
            if(row.ref!==this.state.selectedActivity){continue}
            ls.push(row);
        }
        return ls

    }
    getTitle=()=>{
        let {_this } = this.props;
        let {state} = _this;
        if(state.ActionData!==null){
            return state.ActionData.name;
        }
        return "----"
    }
    onClose=()=>{
        let {_this } = this.props;
        _this.setState({
            showActionActivity:false,
            ActionData:true
        })
    }
    renderModules = () => {
        let ls = [];
        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;
        let data = state.ActionData;
        if(data===null){return ls}
        if(typeof data.record ==="undefined"){return ls}
        let org = data.record.org;
        let project = data.record.module;

        for (let i in state.Activities) {
            const row = state.Activities[i];
            if(row.org!==org){continue}
            if(row.module!==project){continue}

            ls.push({
                key: row.name,
                val: row.name,
            })
        }
        return (
            <Select
                name={"selectedActivity"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedActivity")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }

    render() {
        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;
        let attributes = this.getAttributes()

        let ls = [];
        let loopIndex = 0;
        for (let i = 0; i < attributes.length; i += 2) {
            loopIndex = i;
            const row = attributes[i];
            let row2 = null;
            let nextIndex = i + 1;
            if (nextIndex < (attributes.length)) {
                row2 = attributes[nextIndex]
            }
            ls.push(
                <Row gutter={16}>
                    {makeCol(row, this)}
                    {makeCol(row2, this)}
                </Row>
            );
            console.log("Loop ::::--> ", i, " > ", row.fieldname)
        }

        return (
            <>
                <Drawer
                    title={"Create a new activity for :"+this.getTitle()}
                    width={720}
                    onClose={this.onClose}
                    visible={state.showActionActivity}
                    bodyStyle={{paddingBottom: 80}}
                    footer={
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button onClick={this.onClose} style={{marginRight: 8}}>
                                Cancel
                            </Button>
                            <Button onClick={this.onSubmit} type="primary">
                                Submit
                            </Button>
                        </div>
                    }
                >
                    <Row gutter={16} style={{marginTop: 20}}>
                        <Col span={12}>
                            <Form.Item
                                label={"Select Activity"}
                            >
                                {this.renderModules()}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form layout="vertical" hideRequiredMark>
                        {ls.map(row => {
                            return row;
                        })}

                    </Form>
                </Drawer>
            </>
        )
    }
}
